import { render, staticRenderFns } from "./day-trade.vue?vue&type=template&id=9c882272&scoped=true&"
import script from "./day-trade.vue?vue&type=script&lang=js&"
export * from "./day-trade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c882272",
  null
  
)

export default component.exports